import { get, system } from "styled-system"

/** RN 数字尺寸 → CSS px，兼容 fontSize={12} / fontSize="12" */
export function toPx(value: unknown): string | number | undefined {
  if (value == null) return undefined
  if (typeof value === "number") return `${value}px`
  if (typeof value === "string" && /^\d+$/.test(value)) return `${value}px`
  return value as string | number
}

function fromScale(value: unknown, scale?: Record<string, unknown>) {
  if (value == null) return value
  if (scale) {
    const scaled = get(scale, value as string | number)
    if (scaled != null) return scaled
  }
  return toPx(value)
}

export const webFontSize = system({
  fontSize: {
    property: "fontSize",
    scale: "fontSizes",
    transform: (value, scale) => fromScale(value, scale as Record<string, unknown>),
  },
})

export const webLineHeight = system({
  lineHeight: {
    property: "lineHeight",
    transform: (value) => toPx(value),
  },
})
